// extracted by mini-css-extract-plugin
export default {"ticketsStatusContent":"TicketsStatus_ticketsStatusContent__YHAFg","info":"TicketsStatus_info__e3B3Y","dot":"TicketsStatus_dot__5ZNlN"};